






































































import scssVariable from '@/assets/style/variables.scss';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr, CurrentCampaignType } from '@/store/campaign/types';

import { Report as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { SetCampaign as feedbackTerms } from '@/const/terms/feedback/campaign';
import { EditCampaign as campaignFeedback } from '@/const/terms/feedback/campaign';

import { IAPP, DATE_TYPE } from '@/const/types';
import { ADJUSTMENT_MAP } from '@/const/options';
import { STATUS } from '@/const/status';
import { TableOptionType, DefaultOption } from '@/const/options/DefaultTableOption';
import { 
    CampaignResponse,
    CampaignDataType,
    ICampaignData,
} from './detailTypes';
import { FormResponse } from '@/pages/campaign/editingTypes';

import { RawLocation } from 'vue-router';
import { Table } from 'element-ui';
import { SummaryMethodParams } from 'element-ui/types/table';
import { Grid } from '@toast-ui/vue-grid';

import { ORIGIN_FORMAT } from '@/utils';
import { TUI_FORMAT } from '@/utils/toastGrid_formatter';
import { IGridOptions, DefaultGridOptions, GroupColumnOptions, NumberColumnOptions, DefaultColumnOptions} from '@/const/options/TuiGridTypes';
import { AxiosError, AxiosResponse } from 'axios';

import DateRangePicker from '@/components/ElementComponent/Date/DateRangePicker.vue';
import Select from '@/components/ElementComponent/Select/index.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import ExplainColumn from '@/components/ElementComponent/Column/ExplainColumn.vue';
import PriceColumn from '@/components/ElementComponent/Column/PriceColumn.vue';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';

const campaignModule = namespace('Campaign');

@Component<ReportCampaignDetail>({
    name: 'ReportCampaignDetail',
    components: {
        DateRangePicker,
        Select,
        Grid,
        NumberColumn,
        DateColumn,
        StatusColumn,
        SelectAllColumn,
        ExplainColumn,
        PriceColumn,
        NumberInput,
    },
})
export default class ReportCampaignDetail extends Vue {
    private terms = terms;
    private compTerms = compTerms;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private subLoading: number = 0;
    private isUtilsCollapsed: boolean = false;

    private tableData: CampaignDataType = [];
    private checkedCampaign: CampaignDataType = [];

    private dateValue: DATE_TYPE[] = [((()=> {
        let t = new Date(); t.setDate(t.getDate() - 6);
        return t;
    })()) as DATE_TYPE, new Date()];

    @campaignModule.State('currentCampaign') private currentCampaign!: CurrentCampaignType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign: any;
    
    get date() {
        return [
            moment(this.dateValue[0]).format('YYYYMMDDHH'),
            moment(this.dateValue[1]).format('YYYYMMDDHH'),
        ];
    }

    private cellStyle({row, column, rowIndex, columnIndex}: any) {
        if (columnIndex === 0) return 'font-weight: 600';
        return '';
    }

    private excelDownloadHandler() {
        const table = this.$refs.table as Table;
        const columns = (table as any).columns;
        const json = JSON.stringify(this.tableData);
        const refinedJson = json
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>.[<>a-zA-Z0-9 =\\\/"-]*.<[/]span>/g, '')
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>/g, '')
                .replace(/<i.[\s\S].[a-z]*=.[a-z\"\\-]*><\/i>/g, '')
                .replace(/<\/span>/g, '');
        const rows = JSON.parse(refinedJson);
        let content = `"캠페인 명","앱", 기간\n${this.currentCampaign.name}, ${this.currentCampaign.app && this.currentCampaign.app.name ? this.currentCampaign.app.name : '알 수 없는 앱'}, ${moment(this.dateValue[0]).format('YYYY-MM-DD')} ~ ${moment(this.dateValue[1]).format('YYYY-MM-DD')}\n\n\n`;
        let cnt = 0;
        const keys: string[] = []; 
        columns.forEach((item: any, index: number) => {
            if (item.property) {
                if (keys.length !== 0) content += ',';
                content += '"' + item.label + '"';
                keys.push(item.property);
            }
        });
        rows.forEach((item: ICampaignData) => {
            content += '\n';            
            keys.forEach((key: string, index: number) => {
                if (index !== 0) content += ',';

                content += '"';
                const checkNum = Number.parseFloat(item[key as keyof ICampaignData] as string);

                if (key.toLowerCase().includes('date')) {
                    if (item[key as keyof ICampaignData]) {
                        content += moment(item[key as keyof ICampaignData]).format('YYYY-MM-DD');
                    }
                } else if (key.toLowerCase() === 'ctr') {
                    if (Number.isNaN(checkNum) || checkNum === -1) {
                        content += ' - ';
                    } else {
                        content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                    }
                } else if (!Number.isNaN(checkNum)) {
                    content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                } else if (item[key as keyof ICampaignData]){
                    content += item[key as keyof ICampaignData];
                }
                content += '"';
            })
        })
        const BOM = "\uFEFF";
        content = BOM + content
        const url = window.URL.createObjectURL(new Blob([content], {type: "text/csv"}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `[${terms.campaignDetail.title}][${this.currentCampaign.name}]_${moment(this.dateValue[0]).format('YYYY-MM-DD')}_${moment(this.dateValue[1]).format('YYYY-MM-DD')}.csv`)
        link.click();
        return;
    }
    private handleCampaignSummary(param: SummaryMethodParams) {
        const { columns, data } = param as {columns: any[], data: CampaignDataType};
        const sums = [] as string[];
        columns.forEach((column: any, index: number) => {            
            if (column.label === this.compTerms.column.date) {
                sums[index] = this.currentCampaign.name;
                return;
            }
            const values = data.map((item: ICampaignData | any) => Number(item[column.property]));
            let unit = '';
            if (column.label === this.compTerms.column.impression || column.label === this.compTerms.column.click)
                unit = ' 회';
            if (column.label === this.compTerms.column.ctr) 
                unit = ' %';
            if (column.label === this.compTerms.column.totalBudget ||
                column.label === this.compTerms.column.dailyBudget ||
                column.label === this.compTerms.column.spentBudget  )
                unit = ' 원';

            if (unit !== '' && !values.every((value: number) => isNaN(value))) {
                if (column.label === this.compTerms.column.ctr) {
                    const imp = data.map((item: ICampaignData) => Number(item.impression)).reduce((prev, curr) => prev + (curr > 0 ? curr : 0) , 0);
                    const click = data.map((item: ICampaignData) => Number(item.click)).reduce((prev, curr) => prev + (curr > 0 ? curr : 0) , 0);

                    sums[index] = (imp > 0) ? (ORIGIN_FORMAT.NumberFormatOrigin((click / imp) * 100 ) + unit) : (' - ' + unit);
                } else {
                    sums[index] = ORIGIN_FORMAT.NumberFormatOrigin(values.reduce((prev, curr) => prev + ( curr > 0 ? curr : 0 ), 0)) + unit;
                }
                return;    
            } else if (unit !== ''){
                sums[index] = '-' + unit;
                return;
            }
            sums[index] = '';
        });
        return sums;
    }
    private refreshDate(v: Date[]) {
        if (v) {
            this.getCampaignResponseHandler();
        }
    }

    private getCampaignResponseHandler() {
        this.loading = true;
        this.checkedCampaign = [];
        this.getCampaignResponse().then((res: any) => res.data)
            .then((data: CampaignResponse) => {
                this.tableData = data.sort((a: ICampaignData, b: ICampaignData) => a.reportDate < b.reportDate ? 1 : -1)
                    .map((item: ICampaignData) => {
                        const imp = item.impression;
                        const click = item.click;
                        const ctr = imp === 0 ? '-1' : (click / imp) * 100;
                        return {
                            ...item,
                            ctr: ctr,
                        } as ICampaignData;
                    });
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {
                this.loading = false;
                const table = this.$refs.table as Table;
                this.$nextTick(() => {
                    table.doLayout();
                })
            })
    }

    private getCampaignResponse() {
        return this.$http.adserverAPI.post('GetCampaignDetailReport', {
            campaign_id: this.currentCampaign.id,
            since: this.date[0],
            until: this.date[1],
        })
    }
    
    private async created() {
        if (this.$route.params.campaignID !== this.currentCampaign.id) {
            this.loading = true;
            const campaignID = this.$route.params.campaignID;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID} ).then((res: any) => res.data)
                .then(async (data: FormResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(campaignFeedback.editing.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app:    data.app as IAPP,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(campaignFeedback.new.error.setCurrentCampaign.message);
                                break;
                        }
                        throw new Error(campaignFeedback.new.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(campaignFeedback.editing.error.getResponse);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'reportCampaign'});
                    }
                    throw err;
                })
                .finally(()=>{
                    this.loading = false;
                })
        }
        this.getCampaignResponseHandler();
    }
}
